<template>
  <div id="pageTable">
    <v-container grid-list-xl fluid>
      <v-layout row wrap>
        <app-bar :title="`Xuất thiết bị`"/>
        <v-flex xs12 sm12 md12 lg12 xl12>
          <v-card>
            <v-card-text class="pa-10">
              <v-layout row wrap>
                <v-flex xs12 sm3>
                  <v-text-field :value="loggedUser && loggedUser.accountName" label="Xuất từ" disabled></v-text-field>
                </v-flex>
                <v-flex xs12 sm3>
                  <v-autocomplete
                    v-model="form.accountId"
                    label="Xuất đến"
                    :items="dealers"
                    item-text="name"
                    item-value="id"
                  ></v-autocomplete>
                </v-flex>
                <v-flex xs12 sm3>
                  <v-text-field v-model="form.refCode" label="Mã phiếu xuất hàng"></v-text-field>
                </v-flex>
                <v-flex xs12 sm3>
                  <v-text-field v-model="form.remark" label="Ghi chú"></v-text-field>
                </v-flex>
              </v-layout>
            </v-card-text>
          </v-card>
        </v-flex>
        <v-flex xs12 sm12 md12 lg12 xl12>
          <v-card flat>
            <v-tabs slider-color="primary" color="grey lighten-2" @change="changeTab">
              <v-tab ripple v-if="loggedUser && !loggedUser.isProvider">Chọn thiết bị để xuất</v-tab>
              <v-tab ripple >Xuất thiết bị từ file</v-tab>
              <v-tab-item v-if="loggedUser && !loggedUser.isProvider">
                <mover
                  :leftTitle="`Thiết bị sẵn có `"
                  :rightTitle="`Thiết bị đã chọn `"
                  :datasource="devicesByLoggedAccount"
                  :firstLineProp="`imei`"
                  :secondLineProp="`planCode`"
                  @output="getSelectedDevice($event)"
                />
              </v-tab-item>
              <v-tab-item >
                <v-card class="elevation-0">
                  <v-toolbar card color="white">
                    <v-btn outline round color="primary" @click="pickFile" v-model="fileName" :disabled="devicesByLoggedAccount.length > 10 ? false : true">

                      {{fileName}}
                      <v-icon right>attach_file</v-icon>
                    </v-btn>
                    <input
                      type="file"
                      style="display: none"
                      ref="fileUpload"
                      accept=".xlsx, .xls, .csv"
                      @change="onFilePicked"
                    >
                    <v-spacer></v-spacer>
                    <v-btn
                      flat
                      round
                      color="success"
                      href="/static/Export_Device_Template.xlsx"
                      target="_blank"
                    >Tải file mẫu
                      <v-icon right>cloud_download</v-icon>
                    </v-btn>
                  </v-toolbar>
                  <v-card-text class="pa-0">
                    <export-device-table :isLoading="isLoading" :datasource="deviceViewModels"/>
                  </v-card-text>
                </v-card>
              </v-tab-item>
            </v-tabs>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn flat @click="cancel()">Nhập lại</v-btn>
              <v-btn color="primary" @click="submit()" :loading="isMovingDevice" :disabled="errorExportDevice">Xuất thiết bị</v-btn>
            </v-card-actions>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import * as Utils from '@/utils';
import * as Auth from '@/utils/auth';
import XLSX from 'xlsx';
import AppBar from '@/components/appbar';
import ExportDeviceTable from './components/exportlist';
import Mover from '@/components/mover';

export default {
  components: {
    ExportDeviceTable,
    AppBar,
    Mover
  },
  data () {
    return {
      dealers: [],
      fileName: 'Chọn file',
      deviceViewModels: [],
      isLoading: false,
      devicesByLoggedAccount: [],
      form: {
        devices: [],
        accountId: '',
        refCode: '',
        remark: ''
      },
      isMovingDevice: false,
      errorExportDevice: false
    };
  },
  computed: {
    ...mapGetters(['loggedUser', 'devices'])
  },

  watch: {
    loggedUser (newValue, oldValue) {
      if (!oldValue) this.getDevicesByAccount(newValue);
    }
  },


  mounted () {
    if (!this.devices.length || this.devices.length === 10) this.getDevices(Utils.pagination);
    this.getDealers()
      .then(res => {
        this.dealers = res;
      })
      .catch(err => console.log(err));
    this.getDevicesByAccount();
  },
  methods: {
    ...mapActions([
      'getDevices',
      // 'getDeviceByImei',
      'getDealers',
      'getDeviceByAccount',
      'moveDevices'
    ]),
    pickFile () {
      this.$refs.fileUpload.click();
    },
    async onFilePicked (e) {
      this.isLoading = true;

      const files = e.target.files;
      if (files[0] !== undefined) {
        await this.parseExcelFileToJson(files[0]).then(content => {
          this.deviceViewModels = [];
          this.form.devices = [];
          let arrayDevices = [];

          content.map((item, index) => {
            if (index > 0) {
              this.getDeviceByImei(item[1]).then(resDevice => {
                let device = { ...resDevice };
                let extend = {
                  deviceImei: item[1],
                  deviceType: item[2],
                  planCode: item[3],
                  simSN: item[4],
                  simPhone: item[5],
                  simTelecom: item[6],
                  simProvider: item[7],
                  isValid: false
                };
                console.log('onFilePicked -> device', device);

                extend.isValid = device && device.id ? true : false;
                console.log('onFilePicked -> extend.isValid', extend.isValid);
                
                let merge = device
                  ? {
                    ...device,
                    ...extend
                  }
                  : { ...extend };
                if (merge.deviceImei) {
                  console.log('onFilePicked -> merge.deviceImei', merge.deviceImei);
                  this.deviceViewModels.push(merge);
                  if (merge.isValid) {
                    arrayDevices.push({
                      deviceId: merge.id,
                      planCode: merge.planCode
                    });
                  }
                  else {
                    this.errorExportDevice = true;
                  }
                }
              });
            }
            return 0;
          });
          this.form.devices = arrayDevices;
          this.isLoading = false;
        });
      }
    },
    parseExcelFileToJson (f) {
      this.fileName = `Đã chọn: ${f.name}`;
      return new Promise((resolve, reject) => {
        let reader = new FileReader();
        reader.readAsBinaryString(f);

        reader.onload = e => {
          let data = e.target.result;
          let workbook = XLSX.read(data, {
            type: 'binary'
          });
          let first_worksheet = workbook.Sheets[workbook.SheetNames[0]];
          let content = XLSX.utils.sheet_to_json(first_worksheet, {
            header: 1
          });

          resolve(content);
        };
      });
    },

    getSelectedDevice (list) {
      this.form.devices = [];
      list.map(a => {
        this.form.devices.push({
          deviceId: a.id,
          planCode: a.planCode
        });
        return 0;
      });
    },
    cancel () {
      window.location.reload();
    },
    submit () {
      this.isMovingDevice = true; 
      let test = this.devicesByLoggedAccount.find(a => a.imei === '866005042862914'); 

      this.moveDevices(this.form)
        .then(_ => {
          this.isMovingDevice = false;
          window.getApp.showMessage('Xuất thiết bị thành công');
          window.history.back();
        })
        .catch(err => {
          this.isMovingDevice = false;
          let msg = '';
          if (err === 'ERR_INVALID_PERMISSION') {
            msg =
            'Không thể xuất thiết bị thuộc quyền sở hữu của tài khoản khác';
          } else {
            msg = 'Xuất thiết bị thất bại, vui lòng thử lại';
          }
          window.getApp.showMessage(msg, 'error');
        });
    },

    getDevicesByAccount (user) {
      let loggedUser = user ? user : Auth.getLoggedUser();
      if (!loggedUser) return;
      let accountId = loggedUser.accountId;
      let params = Object.assign({ accountId }, Utils.pagination);

      this.getDeviceByAccount(params)
        .then(res => {
          this.devicesByLoggedAccount = (res && res.data) || [];
        })
        .catch(err => console.log(err));
    },

    // Lấy thông tin device theo imei trong danh sách device của account
    getDeviceByImei (imei) {
      return new Promise((resolve, reject) => {
        let device = this.devicesByLoggedAccount.find(a => a.imei === imei); 
        resolve(device);
      }); 
    },

    changeTab (value) {
      if (value === 0) {
        this.errorExportDevice = false; 
        this.form.devices = [];
        this.deviceViewModels = [];
        if (this.$refs.fileUpload) this.$refs.fileUpload.value = '';
        this.fileName = 'Chọn file';
      }
    }
  }
};
</script>

<style scoped>
#pageTable >>> .v-window__container {
  height: 100% !important;
}
</style>


// WEBPACK FOOTER //
// src/pages/device/export.vue